import { render, staticRenderFns } from "./CommunityEvents.vue?vue&type=template&id=cd116d0a&scoped=true&"
import script from "./CommunityEvents.vue?vue&type=script&lang=js&"
export * from "./CommunityEvents.vue?vue&type=script&lang=js&"
import style0 from "./CommunityEvents.vue?vue&type=style&index=0&id=cd116d0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd116d0a",
  null
  
)

export default component.exports